import { createPinia } from 'pinia'
import { createApp } from 'vue'

import App from './App.vue'
import { router } from './router'
import { clearAuthCallbackTokens, initAnalytics, isAuthTokenCallback, trackPageView } from './services/analytics'
import { captureAttribution, trackVisit } from './services/attribution'
import { useAuthStore } from './stores/auth'
import { installOnboardingGuard } from './services/onboardingNavigation'
import './styles/main.css'

const authCallback = isAuthTokenCallback()
let analyticsStarted = false
function startAnalytics() {
  analyticsStarted = true
  initAnalytics()
  captureAttribution()
  trackVisit()
}
if (!authCallback) startAnalytics()
router.afterEach((to, from) => {
  if (analyticsStarted && (to.path !== from.path || from.matched.length === 0)) trackPageView(to.fullPath)
})

const pinia = createPinia()
installOnboardingGuard(router, pinia)
const application = createApp(App).use(pinia).use(router)

application.mount('#app')
const restoration = useAuthStore(pinia).initialize()
if (authCallback) {
  const finishCallback = async () => {
    // Сначала Supabase читает callback. До этого аналитика не получает URL с токенами.
    await router.isReady()
    clearAuthCallbackTokens()
    startAnalytics()
    trackPageView(router.currentRoute.value.fullPath)
  }
  void restoration.then(finishCallback, finishCallback)
}
